var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAddImageIcon = function SvgAddImageIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M3.33333 17H12.6667C13.403 17 14 16.403 14 15.6667V9M3.33333 17C2.59695 17 2 16.403 2 15.6667V6.33333C2 5.59695 2.59695 5 3.33333 5H9.10761M3.33333 17L10.6667 9.66667L14 13M6.66667 8.66667C6.66667 9.21895 6.21895 9.66667 5.66667 9.66667C5.11438 9.66667 4.66667 9.21895 4.66667 8.66667C4.66667 8.11438 5.11438 7.66667 5.66667 7.66667C6.21895 7.66667 6.66667 8.11438 6.66667 8.66667Z",
    stroke: props.fill,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#add-image-icon_svg__clip0_3616_316)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 1.66666V6.33333",
    stroke: props.fill,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6665 4H16.3332",
    stroke: props.fill,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "add-image-icon_svg__clip0_3616_316"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "white",
    transform: "translate(10)"
  })))));
};
export default SvgAddImageIcon;